import React from 'react';
import { Link } from 'react-router-dom';
import LandingNav from './LandingNav';
import LandingFooter from './LandingFooter';
import './LegalPage.css';

interface LegalPageProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export default function LegalPage({ title, lastUpdated, children }: LegalPageProps) {
  return (
    <div className="legal-page">
      <div className="legal-page__column">
        <LandingNav />
      </div>

      <main id="main" className="legal-page__column">
        <Link to="/" className="legal-page__back">← Back</Link>

        <article className="legal-page__article">
          <header className="legal-page__header">
            <h1 className="legal-page__title">{title}</h1>
            <p className="legal-page__date">Last updated: {lastUpdated}</p>
          </header>
          <div className="legal-page__body">
            {children}
          </div>
        </article>
      </main>

      <div className="legal-page__column">
        <LandingFooter />
      </div>
    </div>
  );
}
